import { Controller } from "@hotwired/stimulus"
import Holder from "holderjs"

export default class extends Controller {
  static targets = ["agendaContainer", "dateContainer", "loadingMessageContainer"]

  connect(){
    if ( this.scrolledToBottom() ) {
      this.loadMore(this.nextPageUrl())
    }
  }

  scroll(){
    if ( this.scrolledToBottom() ) {
      this.loadMore(this.nextPageUrl())
    }
  }

  loadMore(url){
    if(this.data.get("loadInProgress")=="true"){
      return Promise.resolve()
    }
    this.data.set("loadInProgress","true")
    this.showLoadingIndicator()

    return fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      credentials: "same-origin"
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.agendaContainerTarget.insertAdjacentHTML("beforeend", data.entries)
        Holder.run()
        return true
      })
      .catch((error) => {
        console.error("[schedule-infinite-scroll] Unable to load more entries", error)
        return false
      })
      .finally(() => {
        this.data.set("loadInProgress","false")
        this.hideLoadingIndicator()
      })
  }

  scrolledToBottom() {
    var body = document.body,
        html = document.documentElement

    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)

    var anticipation = $("footer").outerHeight()+200

    return (window.pageYOffset >= height - window.innerHeight - anticipation)
  }

  showLoadingIndicator(){
    this.loadingMessageContainerTarget.innerHTML = this.data.get("loadingMessage")
  }

  hideLoadingIndicator(){
    this.loadingMessageContainerTarget.innerHTML = ""
  }

  lastRenderedDate(){
    return this.dateContainerTargets[this.dateContainerTargets.length-1].dataset.date
  }

  nextDate(){
    let lastDate = new Date(this.lastRenderedDate())
    let nextDate = new Date(lastDate.setDate(lastDate.getDate()+1))
    return nextDate.toISOString().split("T")[0]
  }

  nextPageUrl(){
    let params = new URLSearchParams(document.location.search)
    params.set("onlyDate",this.nextDate())

    return document.location.origin + document.location.pathname + "?" + params.toString()
  }

  log(msg){
    console.log("[schedule-infinite-scroll] "+msg)
  }

}
